<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <div class="d-flex align-center justify-center text-center">
          <v-img contain max-width="100" :src="`${publicPath}launcher_icon.png`"></v-img>
          <h1 class="display-2 font-weight-medium mx-2">Drive Safely</h1>
        </div>
      </v-col>
    </v-row>
    <v-row align="center" class="mx-auto my-1" dense>
      <v-col cols="12" class="text-center">
        <span :class="{'headline': ['xs'].includes(this.$vuetify.breakpoint.name)}"
              class="display-1 font-weight-thin text-center"> {{ $vuetify.lang.t(`$vuetify.landing.main.title`) }}</span>
      </v-col>
    </v-row>
    <v-row align="center" align-content="center" justify="center">
      <v-col cols="12" md="6" justify-self="center" align-self="center">
        <v-card flat
                color="transparent" elevation="10" class="mx-md-5">
          <v-img class="mx-auto" aspect-ratio="1.95"
                 :src="require('@/assets/landing/landing_photo.jpg')"></v-img>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" justify-self="center" align-self="center">
        <v-card flat color="transparent" elevation="10" class="mx-md-5">
          <v-responsive aspect-ratio="1.95">
            <iframe width="auto" src="https://www.youtube.com/embed/8av2fr1BcFs" frameborder="0"
                    title="Drive Safely Demo"
                    class="youtube-video mx-auto"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </v-responsive>

        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-3 mx-md-5">
      <v-col cols="12" md="6" align-self="center" :class="flexInline">
        <template v-if="$vuetify.breakpoint.name === 'xs'">
          <p class="subtitle-1 font-weight-medium">{{ $vuetify.lang.t(`$vuetify.landing.main.googleApp`) }}</p>
        </template>
        <template v-else>
          <span class="subtitle-1 font-weight-medium">{{ $vuetify.lang.t(`$vuetify.landing.main.googleApp`) }}</span>
        </template>

        <a
          href='https://play.google.com/store/apps/details?id=ru.igla.drivesafely'>
          <img class="google-link" :alt='googleLogo.label' :src='googleLogo.url'/>
        </a>
      </v-col>
      <v-col cols="12" md="6" align-self="center" :class="flexInline">
        <v-icon x-large>{{ supportLogo }}</v-icon>

        <template v-if="$vuetify.breakpoint.name === 'xs'">
          <p class="mx-2">{{ $vuetify.lang.t(`$vuetify.landing.main.support`) }}</p>
        </template>
        <template v-else>
          <span class="mx-2">{{ $vuetify.lang.t(`$vuetify.landing.main.support`) }}</span>
        </template>

        <span class="mx-2 font-weight-black" :class="{email: !isPrerendered()}" @copy="copyEvent">{{ !isPrerendered() ? email : reversedEmail }}</span>
      </v-col>
    </v-row>

    <v-card color="transparent" elevation="0">
      <v-footer padless color="transparent" class="font-weight-medium text-center">
        <v-row no-gutters justify="center" class="font-weight-light body-2 ">
          <!--          <v-col cols="12">-->
          <!--            <router-link :to="{name: 'legalInformation'}">{{ $vuetify.lang.t(`$vuetify.landing.main.privacy`) }}-->
          <!--            </router-link>-->
          <!--          </v-col>-->
          <v-col cols="12" class="mt-2 black--text">
            &copy; {{ new Date().getFullYear() }} <span
            v-html="$vuetify.lang.t(`$vuetify.landing.main.footer`)"></span>
            <v-spacer class="mt-2"></v-spacer>
            <router-link class="black--text" :to="{name: 'legalInformation'}">{{
              $vuetify.lang.t(`$vuetify.landing.main.privacy`) }}
            </router-link>
          </v-col>
        </v-row>
      </v-footer>
    </v-card>
  </v-container>
</template>

<script>
import { mdiFaceAgent } from '@mdi/js'
import metaMixin from '../../mixins/metaMixin'
import { isPrerendered } from '../../utils/prerender'

export default {
  name: 'mainSlide',
  data: () => ({
    supportLogo: mdiFaceAgent,
    email: 'moc.ylefasevirdelibom@troppus'
  }),
  mixins: [metaMixin],
  computed: {
    publicPath () {
      return process.env.BASE_URL
    },
    flexInline () {
      if (this.$vuetify.breakpoint.name !== 'xs') {
        return 'd-flex align-center justify-center align-content-center'
      } else {
        return 'text-center'
      }
    },
    reversedEmail () {
      return this.email.split('').reverse().join('')
    },
    googleLogo () {
      if (this.$vuetify.lang.current === 'en') {
        return {
          url: require('@/assets/landing/google/en_badge_web_generic.png'),
          label: 'Get it on Google Play'
        }
      } else if (this.$vuetify.lang.current === 'ru') {
        return {
          url: require('@/assets/landing/google/ru_badge_web_generic.png'),
          label: 'Доступно в Google Play'
        }
      } else {
        return {
          url: '',
          label: ''
        }
      }
    }
  },
  methods: {
    copyEvent (event) {
      if (event && 'clipboardData' in event) {
        event.clipboardData.setData('text/plain', [...window.getSelection().toString().replace(/[\n\r]+/g, '')].reverse().join(''))
        event.preventDefault()
      }
    }
  },

  metaInfo: {
    title: 'Drive Safely',
    meta: [
      { name: 'description', content: 'Driver monitoring application using smartphone camera and sensors' },
      { property: 'og:title', content: 'Drive Safely Mobile Application' },
      { property: 'og:site_name', content: 'Drive Safely' },
      { property: 'og:description', content: 'Driver monitoring application using smartphone camera and sensors' },
      { property: 'og:url', content: 'https://mobiledrivesafely.com' }
    ]
  },
  created () {
    this['isPrerendered'] = isPrerendered
  }
}
</script>

<style scoped>
  .google-link {
    height: 85px;
  }

  .youtube-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .email {
    unicode-bidi: bidi-override;
    direction: rtl;
  }
</style>
